import { action } from "@storybook/addon-actions";
import { Meta, StoryFn } from "@storybook/react";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Autocomplete, AutocompleteItem, NumberInput, Select } from ".";
import { Button } from "../Button";
import Flex from "../Flex";
import { Typography } from "../Typography";

export default {
    title: "Form Components"
} as Meta;

type FormValues = {
    favoriteAnimal?: string;
    numericInputWithoutBoundaries?: number;
    numericInputWithBoundaries?: number;
    number: string;
};

const Template: StoryFn = () => {
    const form = useForm<FormValues>({ mode: "onBlur" });

    return (
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        <form onSubmit={form.handleSubmit(action("submitted"))}>
            <Flex column width={500} gap={20}>
                <Controller
                    control={form.control}
                    name="number"
                    render={({ field, fieldState }) => (
                        <Flex flexDirection="column" gap={6}>
                            <Select
                                {...field}
                                controlled
                                error={!!fieldState.error}
                                options={[
                                    { label: "one", value: "1" },
                                    { label: "two", value: "2" },
                                    { label: "three", value: "3" },
                                    { label: "four", value: "4" },
                                    { label: "five", value: "5" },
                                    { label: "six", value: "6" },
                                    { label: "seven", value: "7" },
                                    { label: "eight", value: "8" },
                                    { label: "nine", value: "9" },
                                    { label: "ten", value: "10" }
                                ]}
                                trackName=""
                            />

                            {fieldState.error && (
                                <Typography color="error-600" variant="label-x-small-regular">
                                    {fieldState.error.message}
                                </Typography>
                            )}
                        </Flex>
                    )}
                    rules={{ required: { message: "This field is required", value: true } }}
                />

                <Controller
                    control={form.control}
                    name="numericInputWithoutBoundaries"
                    render={({ field }) => <NumberInput {...field} label="This input has no min-max boundaries" />}
                />

                <Controller
                    control={form.control}
                    name="numericInputWithBoundaries"
                    render={({ field }) => (
                        <NumberInput {...field} label="This input has a min of 4 and a max of 8" min={4} max={8} />
                    )}
                />

                <Controller
                    control={form.control}
                    name="favoriteAnimal"
                    render={({ field, fieldState }) => (
                        <Autocomplete
                            errorMessage={fieldState.error?.message}
                            defaultInputValue={field.value}
                            label="Favorite animal"
                            menuTrigger="focus"
                            name={field.name}
                            onBlur={field.onBlur}
                            onSelectionChange={field.onChange}
                            placeholder="Try with dog ..."
                        >
                            <AutocompleteItem key="dog">Dog</AutocompleteItem>
                            <AutocompleteItem key="cat">Cat</AutocompleteItem>
                            <AutocompleteItem key="snake">Snake</AutocompleteItem>
                        </Autocomplete>
                    )}
                    rules={{ required: { message: "This field is required", value: true } }}
                />

                <Flex alignItems="flex-end" column>
                    <Button title="Submit" type="submit" trackName="" />
                </Flex>
            </Flex>
        </form>
    );
};

export const Default = Template.bind({});
